/**
 * @generated SignedSource<<b93b611b801d76b9086c60b5c9984d03>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useClubHasMemberships_club$data = {
  readonly memberships: {
    readonly count: number;
  } | null | undefined;
  readonly supportsPublic: boolean;
  readonly " $fragmentType": "useClubHasMemberships_club";
};
export type useClubHasMemberships_club$key = {
  readonly " $data"?: useClubHasMemberships_club$data;
  readonly " $fragmentSpreads": FragmentRefs<"useClubHasMemberships_club">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useClubHasMemberships_club",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportsPublic",
      "storageKey": null
    },
    {
      "alias": "memberships",
      "args": [
        {
          "kind": "Literal",
          "name": "packageType",
          "value": "MEMBERSHIP"
        },
        {
          "kind": "Literal",
          "name": "saleAvailability",
          "value": "PUBLIC"
        }
      ],
      "concreteType": "PackageConnection",
      "kind": "LinkedField",
      "name": "packages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": "packages(packageType:\"MEMBERSHIP\",saleAvailability:\"PUBLIC\")"
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "bd9aff51fd89e4e0bdc4b5bb854e56eb";

export default node;
